import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import isArray from 'lodash-es/isArray';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { selectItem } from '@panneau/core/utils';
import Empty from '@panneau/element-empty';
import Loading from '@panneau/element-loading';

var styles = {"container":"panneau-element-grid-container","inner":"panneau-element-grid-inner","xsmall":"panneau-element-grid-xsmall","small":"panneau-element-grid-small","medium":"panneau-element-grid-medium","large":"panneau-element-grid-large"};

var propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    content: PropTypes.oneOf([PropTypes.string, PropTypes.node])
  })),
  component: PropTypes.func,
  componentProps: PropTypes.shape({}),
  size: PropTypes.string,
  gap: PropTypes.string,
  loading: PropTypes.bool,
  loaded: PropTypes.bool,
  empty: PropTypes.bool,
  emptyLabel: PropTypes.node,
  selectable: PropTypes.bool,
  selectedItems: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string
  })),
  multipleSelection: PropTypes.bool,
  onSelectionChange: PropTypes.func,
  className: PropTypes.string
};
var defaultProps = {
  items: [],
  component: null,
  componentProps: null,
  size: null,
  gap: null,
  loading: false,
  loaded: false,
  empty: null,
  emptyLabel: null,
  selectable: false,
  selectedItems: null,
  multipleSelection: false,
  onSelectionChange: null,
  className: null
};
var Grid = function Grid(_ref) {
  var items = _ref.items,
    component = _ref.component,
    componentProps = _ref.componentProps,
    size = _ref.size,
    gap = _ref.gap,
    loading = _ref.loading,
    loaded = _ref.loaded,
    empty = _ref.empty,
    emptyLabel = _ref.emptyLabel,
    selectable = _ref.selectable,
    selectedItems = _ref.selectedItems,
    onSelectionChange = _ref.onSelectionChange,
    multipleSelection = _ref.multipleSelection,
    className = _ref.className;
  var Component = component || null;
  var onSelectItem = useCallback(function () {
    var newItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    selectItem(newItem, selectedItems, onSelectionChange, multipleSelection);
  }, [items, selectedItems, onSelectionChange, multipleSelection]);
  var finalSelectedItems = useMemo(function () {
    if (selectedItems === null) {
      return null;
    }
    return isArray(selectedItems) ? selectedItems : [selectedItems];
  }, [selectedItems]);

  // const onSelectPage = useCallback(
  //     (pageSelected = false) => {
  //         selectPage(pageSelected, items, selectedItems, onSelectionChange);
  //     },
  //     [items, selectedItems, onSelectionChange],
  // );

  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty(_defineProperty({}, styles[size], size !== null), className, className !== null)]),
    style: gap !== null ? {
      'grid-gap': gap
    } : null
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.inner
  }, Component !== null ? (items || []).map(function (item, idx) {
    var _ref3 = item || {},
      _ref3$id = _ref3.id,
      itemId = _ref3$id === void 0 ? null : _ref3$id,
      _ref3$actionsDisabled = _ref3.actionsDisabled,
      actionsDisabled = _ref3$actionsDisabled === void 0 ? false : _ref3$actionsDisabled,
      _ref3$selectionDisabl = _ref3.selectionDisabled,
      selectionDisabled = _ref3$selectionDisabl === void 0 ? false : _ref3$selectionDisabl;
    var itemSelectable = selectionDisabled ? false : selectable;
    var selected = itemSelectable ? ((finalSelectedItems || []).find(function () {
      var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref4$id = _ref4.id,
        id = _ref4$id === void 0 ? null : _ref4$id;
      return id === itemId;
    }) || null) !== null : false;
    return /*#__PURE__*/React.createElement(Component, Object.assign({
      key: "item-".concat(itemId, "-").concat(idx + 1),
      value: item,
      selectable: itemSelectable,
      selected: itemSelectable && selected,
      actionsDisabled: actionsDisabled
    }, componentProps, itemSelectable && onSelectionChange !== null ? {
      onClick: function onClick() {
        return onSelectItem(item);
      },
      selected: selected
    } : null));
  }) : null), loading && !loaded && (items === null || items.length === 0) ? /*#__PURE__*/React.createElement(Loading, {
    withDelay: true
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "TV3jir",
    defaultMessage: [{
      "type": 0,
      "value": "Loading"
    }]
  })) : null, empty || !loading && loaded && (items === null || items.length === 0) ? /*#__PURE__*/React.createElement(Empty, {
    withDelay: true
  }, emptyLabel || /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "uN/FYD",
    defaultMessage: [{
      "type": 0,
      "value": "No results found"
    }]
  })) : null);
};
Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;

export { Grid as default };
